export const BRAND = {
  name: "INC. Cleaning Services",
  registration: "001581631-H",
  tagline: "We Don't Cut Corners, We Clean Them",
  experienceYears: 21,
  owner: "Derick Khoo",
  phones: ["019-731 8121"],
  whatsapp: "https://wa.me/60197318121",
  whatsappText:
    "Hi%20Derick%2C%20I%27d%20like%20a%20cleaning%20quote%20from%20INC.%20Cleaning.",
  address:
    "21, Mesra Terrace, 7, Jalan Dutamas Raya, 51200 Kuala Lumpur",
  email: "inccleaningservices.kl@gmail.com",
};

export const SERVICES = [
  {
    title: "Regular Cleaning",
    blurb:
      "Weekly or fortnightly upkeep that keeps homes and offices effortlessly fresh.",
    tag: "01",
  },
  {
    title: "Complete Cleaning",
    blurb:
      "Top-to-bottom deep cleans for every corner, baseboard and surface.",
    tag: "02",
  },
  {
    title: "Customised Cleaning",
    blurb:
      "Pick the rooms, the timing, the priorities — we build a checklist around you.",
    tag: "03",
  },
  {
    title: "Move-in / Move-out",
    blurb:
      "Hand back spotless keys or move into a home that smells brand new.",
    tag: "04",
  },
  {
    title: "Festive Cleaning",
    blurb:
      "Raya, CNY, Deepavali, Christmas — guest-ready before the doorbell rings.",
    tag: "05",
  },
  {
    title: "Exterior Cleaning",
    blurb:
      "Façades, balconies, driveways and outdoor furniture — handled.",
    tag: "06",
  },
  {
    title: "Part-time Maids",
    blurb:
      "Trusted, bonded cleaners on a flexible schedule that fits your week.",
    tag: "07",
  },
  {
    title: "Stain Removal",
    blurb:
      "Coffee, wine, ink, grease — we know which solvent meets which surface.",
    tag: "08",
  },
];

export const WHY_US = [
  { num: "01", title: "Bonded & Insured", body: "Every cleaner is vetted, bonded and fully insured for your peace of mind." },
  { num: "02", title: "Highly Trained", body: "Professionally trained on equipment, chemicals and protocols." },
  { num: "03", title: "Trustworthy", body: "21 years of repeat clients across Klang Valley homes and offices." },
  { num: "04", title: "Punctual", body: "We arrive on time, every time — your schedule is the brief." },
  { num: "05", title: "Reliable", body: "Show-up rate that owners actually rave about. No-shows aren't a thing here." },
  { num: "06", title: "Friendly", body: "Respectful, soft-spoken teams who treat your space like their own." },
];

export const PACKAGES = [
  {
    name: "Regular Weekly",
    forWhom: "Once-a-week recurring",
    priceLabel: "RM 125",
    priceSuffix: "/ session",
    duration: "2 cleaners · 2 hours",
    bullets: [
      "Same cleaners every visit",
      "Vacuum & mop all floors",
      "Bathrooms & kitchen wipe-down",
      "Surface dusting & tidy",
      "Vacuum & detergents included",
      "Flexible weekly slot",
    ],
    highlight: true,
  },
  {
    name: "General Cleaning",
    forWhom: "One-off · ad-hoc",
    priceLabel: "RM 130",
    priceSuffix: "/ session",
    duration: "2 cleaners · 2 hours",
    bullets: [
      "Surface dusting & wipe-down",
      "Vacuum & mop all floors",
      "Bathrooms scrubbed",
      "Kitchen counters & sink",
      "Vacuum & detergents included",
      "Book any day of the week",
    ],
    highlight: false,
  },
  {
    name: "Move-in / Move-out",
    forWhom: "Post-renovation · handover",
    priceLabel: "RM 160",
    priceSuffix: "/ session",
    duration: "2 cleaners · 2 hours",
    bullets: [
      "Deep clean every room",
      "Inside cabinets & wardrobes",
      "Post-reno dust & debris",
      "Small ladder for high reach",
      "Vacuum & detergents included",
      "Spotless handover-ready",
    ],
    highlight: false,
  },
];

export const TESTIMONIALS = [
  {
    quote:
      "Derick's team has cleaned our condo for 4 years. Never once a no-show, never once a complaint.",
    name: "Mei Ling",
    role: "Mont Kiara · Homeowner",
  },
  {
    quote:
      "After our renovation the unit was a disaster. INC. handed it back move-in ready in a single day.",
    name: "Arjun S.",
    role: "Bangsar · Property Owner",
  },
  {
    quote:
      "We use them for our office pantry and washrooms. Punctual, polite, and quietly thorough.",
    name: "Sarah Tan",
    role: "Office Manager · KL Sentral",
  },
  {
    quote:
      "Festive cleaning before Diwali, Hari Raya and CNY — entire house spotless in 6 hours. Booking again next year.",
    name: "Jocelyn W.",
    role: "Desa ParkCity",
  },
];

export const FAQ = [
  {
    q: "Which areas in Kuala Lumpur do you service?",
    a: "We cover the entire Klang Valley — KL, Petaling Jaya, Subang, Damansara, Mont Kiara, Bangsar, Cheras, Setapak and surrounding areas. For locations outside KL, give us a call to confirm.",
  },
  {
    q: "Are your cleaners bonded and insured?",
    a: "Yes. Every cleaner on our team is background-checked, bonded and covered under our service insurance. We've maintained this standard for all 21 years of operation.",
  },
  {
    q: "Do you bring your own equipment and supplies?",
    a: "Absolutely. We arrive with professional-grade vacuums, eco-conscious chemicals, microfibre, mops, ladders and specialised tools — no need to provide anything on your end.",
  },
  {
    q: "Can I book a part-time maid on a recurring schedule?",
    a: "Yes. Many of our clients have a recurring weekly or fortnightly slot with the same cleaner. Consistency is something we take seriously.",
  },
  {
    q: "How do I get a quote?",
    a: "Send us a WhatsApp message or fill in the contact form below with the type of property, square footage and services needed. Derick personally replies within working hours.",
  },
  {
    q: "What's your cancellation policy?",
    a: "Cancellations made 24 hours in advance are free of charge. Same-day cancellations may incur a partial fee to cover the team's time.",
  },
  {
    q: "Do you also provide helpers and temporary maids?",
    a: "Yes — we offer temporary maids, part-time maids and event helpers (functions, dinners, post-party clean-ups). Just ask.",
  },
];
